import { canPurgeData } from '@/auth/roles.js';
import { TabPageDefinition } from '@/components/tab-pages.js';

export const districtDetailsTabs = (params: Record<string, string>, selectedTab?: string): TabPageDefinition[] => {
  return [
    {
      label: 'General',
      linkProps: {
        to: '/orgs/$orgId',
        params: { orgId: params.orgId },
      },
      isSelectedTab: selectedTab === 'general',
    },
    {
      label: 'Settings',
      linkProps: {
        to: '/orgs/$orgId/settings',
        params: { orgId: params.orgId },
      },
      isSelectedTab: selectedTab === 'settings',
      shouldRender: canPurgeData,
    },
  ];
};
